export default class CampaignSmsEditorCtrl {
    constructor($scope, $q, $state, $stateParams, $sce, $filter, SideMenu, Tag, Segment, Rest, Subscriber, Events, Campaign, Setting, SmsService, TextMessage, StringUtils) {
        SideMenu.setActive('campaign');

        this._stateParams = $stateParams;
        this._sce = $sce;
        this._state = $state;
        this._q = $q;
        this._filter = $filter;
        this._scope = $scope;

        this.tagRepo = Tag;
        this.segmentationRepo = Segment;
        this.restRepo = Rest;
        this.subscriberRepo = Subscriber;
        this.campaignRepo = Campaign;
        this.settingRepo = Setting;
        this.textMessageRepo = TextMessage;
        this.eventHandler = Events;
        this.smsService = SmsService;
        this.stringUtils = StringUtils;

        this.loadedTags = false;
        this.loadedSubscribers = false;
        this.loadedSegments = false;
        this.recipients = [];
        this.savedMessages = [];
        this.linkInserted = false;
        this.stopMessage = '';
        this.stopMessageLength = 0;
        this.unvalidDrafMessages = {
            contentLength: '',
            invalidCharacter: '',
            sender: '',
            recipients: ''
        };

        this.tagIdToName = [];
        this.subscriberIdToEmail = [];
        this.availableLanguages = [];
        this.NUM_CHARS_SMS = 160;
        this.MAX_SMS = 5;

        this.campaign = {
            subscribers: [],
            tags: [],
            segments: [],
            textMessage: {
                from_name: '',
                content: '',
                contentNotTrimmed: '',
                language: 'sv'
            },
            message_type_id: 2,
            message_type: 'text_message'
        };

        if (this._stateParams.id) {
            this.campaignRepo.find(this._stateParams.id, this.campaign.message_type_id).then((campaign) => {
                this.campaign = campaign.data;
                this.campaign.textMessage = campaign.data.textMessage.data;
                this.smsService.setTextMessage(this.campaign.textMessage);

                if (campaign.campaign_status_id === 4) {

                    // Fetch schedule.
                    this.campaignRepo.getSchedule(this.campaign.id, 'scheduled', this.campaign.message_type_id).then((schedule) => {
                        this.scheduledFor = moment(schedule.date, 'YYYY-MM-DD HH:mm');
                        this.scheduledFor.hours(parseInt(schedule.time.hour));
                        this.scheduledFor.minutes(parseInt(schedule.time.minutes));
                        this.scheduledFor = this.scheduledFor.format('YYYY-MM-DD HH:mm');
                    });
                }

                this.campaign.message_type = 'text_message';

                this.getHistoryMeta();

                this.insertRecipients(campaign);

                this.campaignRepo.getLatestTextMessageContent(this.campaign.id).then((response) => {
                    this.smsService.setTextMessage({
                        content: this.stringUtils.trimWithLeaveTrailNewline(
                            response.content.replace('%TextMessage:Stop%', '')
                        )
                    });
                });
            });

            this.settingRepo.findSenderDetail().then((details) => {
                this.smsService.setStopMessage(details.text_message_stop);
                this.smsService.setCustomDomain(details.shortener_domain);
            });
        } else {
            this.settingRepo.findSenderDetail().then((details) => {
                this.smsService.setTextMessage({
                    subject: '',
                    from_name: details.text_message_sender_name || details.name || '',
                    content: ''
                });
                this.smsService.setStopMessage(details.text_message_stop);
                this.smsService.setCustomDomain(details.shortener_domain);
                this._scope.$broadcast('smsEditor:language:toggle', 'sv');
            });
        }

        this._scope.$on("historyContentSelect", (event, contentId) => {
            this.getHistoryHtml(contentId);
        });

        this._scope.$watch('stopMessage', this.calculateStopMessageLength());

        this._scope.$watch('campaign.textMessage.language', (newValue, oldValue) => {
            if (newValue) {
                this._scope.$broadcast('mailEditor:language:toggle', newValue);
                this.calculateStopMessageLength();
            }
        });
        this._scope.$on('smsEditor:language:toggle', (event, currentLanguage) => {
            this.campaign.textMessage.language = currentLanguage;
        });
    }

    getHistoryMeta() {
        this.campaignRepo.getHistoryMeta(this._stateParams.id).then((displayList) => {
            this.historySelect = displayList.data[0].id;
            this.historyMeta = displayList.data;
        });
    };

    trimSenderLength() {
        let sender = this.smsService.textMessage.from_name;

        if (sender.length > 11) {
            this.smsService.textMessage.from_name = sender.slice(0, 11 - sender.length);
        }
    };

    trimSMSLength() {
        var content = this.campaign.textMessage.content;
        this.campaign.textMessage.contentNotTrimmed = this.campaign.textMessage.content;
        let length = content.replace(/[\t ]+/g, ' ').length + this.stopMessage.length;

        if (length > this.MAX_SMS * this.NUM_CHARS_SMS) {
            this.campaign.textMessage.content = this.campaign.textMessage.content.slice(0, this.MAX_SMS * this.NUM_CHARS_SMS - length);
        }
    };

    validRecipient() {
        this.errorMessage = 'CAMPAIGN:FLASH:INVALID_RECIPIENTS';

        return this.campaign.subscribers.length > 0 ||
            this.campaign.tags.length > 0 ||
            this.campaign.segments.length > 0;
    };

    validSender() {
        this.errorMessage = 'CAMPAIGN:FLASH:INVALID_SENDER';

        let regexCustomField = /\[CustomField:(.*?)\.(.*?)\]/;

        return this.smsService.textMessage.from_name &&
            this.smsService.textMessage.from_name.length > 0 &&
            (this.smsService.textMessage.from_name.length <= 11 ||
            regexCustomField.test(this.smsService.textMessage.from_name));
    };

    validSms() {
        this.errorMessage = 'CAMPAIGN:FLASH:INVALID_SMS';
        return this.smsService.validSMS();
    };

    validDraft() {
        return this.validSender() && this.validSms();
    };

    getHistoryHtml(contentId) {
        let historyItem = this.historyMeta.filter((item) => {
            return item.id == contentId;
        })[0];

        let textMessageContentID = historyItem.id;
        let textMessageId = historyItem.text_message_id;
        this.textMessageRepo.getContent(textMessageId, textMessageContentID).then((result) => {
            this.smsService.setTextMessage({
                content: this.stringUtils.trimWithLeaveTrailNewline(result.content.replace('%TextMessage:Stop%', ''))
            });
        });
    };

    summary() {
        this.save(true).then(() => {
            this._state.go('campaign.summary', { id: this.campaign.id , type: 'text_message'});
        });
    };

    save(summary = false) {
        this.campaign.textMessage = angular.copy(this.smsService.textMessage);
        this.campaign.textMessage.content = this.stringUtils.trimWithLeaveTrailNewline(this.smsService.textMessage.content);
        this.campaign.textMessage.contentNotTrimmed = this.smsService.textMessage.content;
        var deferred = this._q.defer();
        if (this.validDraft()) {
            if (this._stateParams.id) {
                this.campaignRepo.update(this._stateParams.id, this.campaign).then((response) => {
                    this.eventHandler.flashEvent('notification', this._filter('translate')('CAMPAIGN:FLASH:SAVED'));
                    this.getHistoryMeta();
                    deferred.resolve();
                }).catch(error => {
                    if(error.status == 400) {
                        this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:FLASH:INVALID_CHARS'));
                        deferred.reject();
                    }
                });
            } else {
                this.campaignRepo.create(this.campaign).then((response) => {
                    this.campaign = response;
                    this.eventHandler.flashEvent('notification', this._filter('translate')('CAMPAIGN:FLASH:CREATED'));
                    if (!summary) {
                        this._state.go('campaign.edit', { 'id': response.id, 'type': 'text_message' });
                    }
                    deferred.resolve();
                }).catch(error => {
                    if(error.status == 400) {
                        this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:FLASH:INVALID_CHARS'));
                        deferred.reject();
                    }
                });
            }
        } else {
            this.eventHandler.flashEvent('error', this._filter('translate')(this.errorMessage));
        }

        return deferred.promise;
    };

    isSaved(index) {
        return this.savedMessages[index];
    };

    insertRecipients() {
        if (this.campaign.tags) {
            this.loadedTags = this.campaign.tags;

            _.map(this.campaign.tags, (tag) => {
                this.tagIdToName[tag.id] = tag.name;
            });
        }

        if (this.campaign.subscribers) {
            this.loadedSubscribers = this.campaign.subscribers;

            _.map(this.campaign.subscribers, (subscriber) => {
                this.subscriberIdToEmail[subscriber.id] = subscriber.email;
            });
        }

        if (this.campaign.segments) {
            this.loadedSegments = this.campaign.segments;

            _.map(this.campaign.segments, (segment) => {
                this.tagIdToName[segment.id] = segment.name;
            });
        }
    };

    calculateStopMessageLength() {
        this.stopMessageLength = this.smsService.getStopMessageLength();
    };
}
